export default function displayFloodZoneInfo(results) {
    let s = "<h3>Flood Hazard Zones</h3><a target='_blank' rel='noopener noreferrer' href='https://www.floodsmart.gov/flood-zones-and-maps'>Flood Zone Explanation</a>";
    s += "<table class='table-responsive'><thead><th><b>Flood Zone Type</b></th><th><b>In/Out</b></th></thead>";

    const displayedPairs = new Set();

    for (let i = 0, il = results.features.length; i < il; i++) {
        const featureAttributes = results.features[i].attributes;

        let sha = featureAttributes["SFHA_TF"] === "T" ? "In" : "Out";

        const keyValuePair = `${featureAttributes["FLD_ZONE"]}-${sha}`;

        if (!displayedPairs.has(keyValuePair)) {
            displayedPairs.add(keyValuePair); 
            s += `<tr><td>${featureAttributes["FLD_ZONE"]}</td>`;
            s += `<td>${sha}</td></tr>`;
        }
    }

    s += "</table>";
    return s;
}
